import { supabase } from '../supabase/client';
import { Session } from '@supabase/supabase-js';

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export const sessionManager = {
  async initialize() {
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
      this.startSessionTimer();
    }
    
    supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN') {
        this.startSessionTimer();
      } else if (event === 'SIGNED_OUT') {
        this.clearSessionTimer();
      }
    });
  },

  startSessionTimer() {
    this.clearSessionTimer();
    this.sessionTimer = setTimeout(() => {
      supabase.auth.signOut();
    }, SESSION_TIMEOUT);
  },

  clearSessionTimer() {
    if (this.sessionTimer) {
      clearTimeout(this.sessionTimer);
    }
  },

  sessionTimer: null as NodeJS.Timeout | null,

  async refreshSession() {
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      this.startSessionTimer();
    }
    return data.session;
  },

  async getCurrentSession(): Promise<Session | null> {
    const { data: { session } } = await supabase.auth.getSession();
    return session;
  }
};